let expressAvgiftArtikel;
let postnummerMin;
let postnummerMax;

let freeGiftEnabled = false;
let freeGiftProduct;

let state = {
  deliverymonth: null,
  postnummerValid: false,
  quantity: 1,
  pantRetur: 0,
  variant: null,
  buyboxBlockVisible: false,
  purchaseType: 'one_time',
  sellingPlan: null,
}

// Loading state for add to cart button (default and popup)
let isButtonLoading = false;

// Inventory cache for upsells
let upsellInventoryCache = {};

// Popup inventory cache for upsells
let popupUpsellInventoryCache = {};

// Product metadata
const productMetadata = JSON.parse(document.getElementById('product-metadata').textContent);

const pantSackArtikel = productMetadata.pantsack;

// Upsell metadata
const upsellMetadata = JSON.parse(document.getElementById('upsell-metadata').textContent);

// Result from the last calculadeTotalPrice run, shared with the buybox via getOrderPricing
let orderPricing = null;

function findSellingPlanByName(plans, planName) {
  return plans?.find((plan) => plan.name === planName) ?? null;
}

// Net sack deposit after return offset; uses matching selling plan price when planName is set
function getPantNetAmount(planName = null) {
  const { sackCount, returOffset } = calculateSackPant();
  let pantPrice = 100;
  let amount = 0;

  if (sackCount > 0) {
    if (planName) {
      const plan = findSellingPlanByName(pantSackArtikel.selling_plans, planName);
      if (plan?.price) pantPrice = plan.price;
    }

    amount += pantPrice * sackCount;
  }

  if (returOffset > 0) {
    amount -= returOffset * pantPrice;
  }

  return amount;
}

// Sum upsell line items; planName picks subscription price when comparing selling plans
function getUpsellTotal(planName) {
  let amount = 0;

  for (const [variantId, count] of Object.entries(upsellInventoryCache)) {
    if (count <= 0) continue;

    const upsell = upsellMetadata[variantId];
    if (!upsell) {
      console.warn(`Upsell variant ID ${variantId} not found in metadata.`);
      continue;
    }

    if (planName) {
      const plan = findSellingPlanByName(upsell.selling_plans, planName);
      amount += (plan?.price ?? upsell.price) * count;
    } else {
      amount += upsell.price * count;
    }
  }

  return amount;
}

function getOneTimeProductPrice() {
  const discountMultiplier = getBestDiscount();
  const productSubtotal = productMetadata.unit_price * state.quantity;
  return productSubtotal - productSubtotal * (discountMultiplier / 100);
}

// Express fee only applies to immediate delivery
function getExpressFee() {
  return state.deliverymonth === 'now' ? (productMetadata.express_fee) : 0;
}

// Create upsell cart item
function createUpsellCartItem(variantId, count) {
  const item = {
    id: variantId,
    quantity: count,
  };

  // If subscription, add selling plan
  if (state.purchaseType === 'subscription' && state.sellingPlan) {
    const upsell = upsellMetadata[variantId];
    const plan = findSellingPlanByName(upsell?.selling_plans, state.sellingPlan.name);

    if (plan) {
      item.selling_plan = plan.id;
    }
  }

  return item;
}

// Build variant state for buybox (price + selling plans scaled to quantity)
// Volume discount applies to both one-time and subscription prices
function getVariantState() {
  const discountMultiplier = getBestDiscount();
  const volumeFactor = 1 - discountMultiplier / 100;
  const price = productMetadata.unit_price * state.quantity * volumeFactor;

  const selling_plans = (productMetadata.selling_plans || []).map((plan) => ({
    id: plan.id,
    name: plan.name,
    price: plan.price * state.quantity * volumeFactor,
  }));

  return {
    id: productMetadata.id,
    price: price,
    selling_plans,
  };
}

state.variant = getVariantState();

// Shared subscription buybox (vedkungen-buybox.js)
const buybox = window.VedkungenBuybox?.create({
  state,
  onPriceChange: calculadeTotalPrice,
  getOrderPricing: () => orderPricing,
});

calculadeTotalPrice();
buybox?.init(state.variant);

/* Event handlers */

// On page show, reset delivery month select and quantity slider
window.addEventListener('pageshow', function () {
  document.querySelector('.delivery-month-select').selectedIndex = 0;
  const slider = document.querySelector('#quantity-slider');
  slider.value = slider.min;
});

// Show buybox only when both delivery month and postnummer are valid
function syncBuyboxVisibility() {
  if (state.deliverymonth && state.postnummerValid) {
    buybox?.show();
  } else {
    buybox?.hide();
  }
}

// On change of delivery month select, recaclulate price
document.querySelector('.delivery-month-select').addEventListener('change', function () {
  state.deliverymonth = this.value;
  calculadeTotalPrice();
  this.classList.remove('empty');

  syncBuyboxVisibility();
});

// Quantity slider touch start
// Not supported on most devices, but it also prevents X-axis movement
document.querySelector('#quantity-slider').addEventListener('touchstart', function () {
  if (navigator.vibrate) navigator.vibrate(50);
});

// Quantity slider change event handler
document.querySelector('#quantity-slider').addEventListener('input', function () {
  state.quantity = parseInt(this.value, 10);

  const qntLabel = document.querySelector('#quantity-label');
  qntLabel.textContent = `${this.value} st`;

  state.variant = getVariantState();
  buybox?.update(state.variant);
  calculadeTotalPrice();

  // Vibrate on supported devices
  if (navigator.vibrate) {
    navigator.vibrate(50);
  }
});

// Upsell quantity change event handler
document.querySelector('dbtfy-slider-component.buyform').addEventListener('change', function (e) {
  if (e.target.matches('.quantity__input')) {
    const variantId = parseInt(e.target.dataset.quantityVariantId, 10);
    const newQty = parseInt(e.target.value, 10);

    if (newQty > 0) {
      upsellInventoryCache[variantId] = newQty;
    } else {
      delete upsellInventoryCache[variantId];
    }

    calculadeTotalPrice();
  }
});

// Handle sack pant retur
document.getElementById('returpant-slider').addEventListener('input', function () {
  let antalSackar = parseInt(this.value, 10);
  const pantLabel = document.querySelector('#returpant-label');

  // Ensure value stays within bounds
  if (antalSackar < 0) this.value = 0;
  if (antalSackar > 12) this.value = 12;
  antalSackar = parseInt(this.value, 10);

  // Set values
  pantLabel.textContent = `${antalSackar} st`;
  state.pantRetur = antalSackar;
  calculadeTotalPrice();
});

// Add to cart button click event handler
document.querySelector('.button--cartadd').addEventListener('click', function (e) {
  e.preventDefault();

  // Return if loading
  if (isButtonLoading) return;

  // Return if no delivery month selected
  if (!state.deliverymonth) return;

  // Return if postnummer is not valid
  if (!state.postnummerValid) return;

  setCartLoading(this, true);
  onAddToCart(this);
});

// Set 'add to cart' loading state
function setCartLoading(btn, enabled) {
  isButtonLoading = enabled;

  if (enabled) {
    btn.classList.add('loading');
    btn.querySelector('.loading__spinner')?.classList.remove('hidden');
  } else {
    btn.classList.remove('loading');
    btn.querySelector('.loading__spinner')?.classList.add('hidden');
  }
}

// Handle stock on load
customElements.get('storsack-buyform') || customElements.define('storsack-buyform', class extends HTMLElement {
  constructor() {
    super(),
      this.inventoryQuantity = parseInt(this.dataset.inventoryQuantity, 10);

    expressAvgiftArtikel = this.dataset.expressavgiftId;

    postnummerMin = parseInt(this.dataset.postnummerMin, 10);
    postnummerMax = parseInt(this.dataset.postnummerMax, 10);

    freeGiftEnabled = this.dataset.freeGiftEnable === 'true';
    freeGiftProduct = this.dataset.freeGiftProduct;

    // Render stock label, returns bool if out of stock is true
    let isSoldOut = this.setAvailableStockLabel(this.inventoryQuantity > 0, this.inventoryQuantity);

    // Is the product sold out?
    if (isSoldOut) {

      // Show reservation notice
      document.querySelector('.reservation-notice').style.display = 'unset';

      // Only allow reservation months August (8)–December (12)
      const select = document.querySelector('.delivery-month-select');
      if (select) {
        const options = Array.from(select.querySelectorAll('option'));

        options.forEach((option) => {
          const value = option.value;

          // Always keep the placeholder
          if (value === 'none') return;

          // Remove express / immediate option when sold out
          if (value === 'now') {
            option.remove();
            return;
          }

          // Expect values like "2026-03"
          const parts = value.split('-');
          if (parts.length === 2) {
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const currentYear = new Date().getFullYear();

            // Remove months before August (8), but allow months of later years
            if (!Number.isNaN(month) && month < 8 && year <= currentYear) {
              option.remove();
            }
          }
        });

        // Reset selection after pruning options
        select.selectedIndex = 0;
        select.classList.add('empty');
        state.deliverymonth = null;
      }
    } else {
      // Sets max inventory if its limited (<12)
      this.setMaxQuantity(this.inventoryQuantity);
    }
  }

  setAvailableStockLabel(inStock, quantity) {
    const obj = document.querySelector('.stock-indicator');

    let addClass;
    let addLabel;
    let isSoldOut = false;

    if (inStock) {
      if (quantity > 20) {
        addClass = 'in-stock';
        addLabel = 'I lager';
      } else if (quantity < 1) {
        addClass = 'out-of-stock';
        addLabel = 'Reservera (tillfälligt slutsålt)';
        isSoldOut = true;
      } else {
        addClass = 'warning';
        addLabel = `Endast ${quantity} säckar i lager!`;
      }
    } else {
      addClass = 'out-of-stock';
      addLabel = 'Reservera (tillfälligt slutsålt)';
      isSoldOut = true;
    }

    obj.classList.add(addClass);
    document.querySelector('#instock-label').innerText = addLabel;
    return isSoldOut;
  }

  setMaxQuantity(inventoryCount) {
    const slider = document.querySelector('#quantity-slider');

    if (inventoryCount < 12) {
      slider.max = inventoryCount;
    }
  }
});

// Calculate full order pricing and update all price UI (summary + buybox)
function calculadeTotalPrice() {
  const discountMultiplier = getBestDiscount();
  const productSubtotal = productMetadata.unit_price * state.quantity;
  const expressFee = getExpressFee();
  const oneTimeProduct = getOneTimeProductPrice();
  const oneTimePant = getPantNetAmount();
  const oneTimeUpsells = getUpsellTotal();
  const oneTimeTotal = oneTimeProduct + oneTimePant + oneTimeUpsells + expressFee;

  // Build per-plan totals so buybox can compare one-time vs each subscription option
  const volumeFactor = 1 - discountMultiplier / 100;
  const selling_plans = (productMetadata.selling_plans || []).map((plan) => {
    const productPrice = plan.price * state.quantity * volumeFactor;
    const pantAmount = getPantNetAmount(plan.name);
    const upsellAmount = getUpsellTotal(plan.name);
    const total = productPrice + pantAmount + upsellAmount + expressFee;

    return {
      id: plan.id,
      name: plan.name,
      price: productPrice,
      total,
    };
  });

  const isSubscription = state.purchaseType === 'subscription' && state.sellingPlan;
  const activePlanName = isSubscription ? state.sellingPlan.name : null;
  let total = 0;
  let savedAmount = 0;

  if (isSubscription) {
    const planPricing = selling_plans.find((plan) => plan.id === state.sellingPlan.id);
    total = planPricing?.total ?? state.sellingPlan.price;
    savedAmount = oneTimeTotal - total;
  } else {
    total = oneTimeTotal;
    savedAmount = productSubtotal * (discountMultiplier / 100);
  }

  orderPricing = {
    oneTimeProduct,
    oneTimeTotal,
    expressFee,
    selling_plans,
    total,
    savedAmount,
  };

  const discountLabel = document.querySelector('#discount-price');
  const upsellLabel = document.querySelector('#upsell-price');
  const returPantLabel = document.querySelector('#returpant-price');
  returPantLabel.innerHTML = '';

  if (savedAmount > 0) {
    discountLabel.textContent = `Du sparar ${formatMoney(savedAmount)}`;
    discountLabel.style.display = '';
  } else {
    discountLabel.style.display = 'none';
  }

  const { sackCount, returOffset } = calculateSackPant();
  let pantUnitPrice = 100;

  if (activePlanName) {
    const plan = findSellingPlanByName(pantSackArtikel.selling_plans, activePlanName);
    if (plan?.price) pantUnitPrice = plan.price;
  }

  if (sackCount > 0) {
    const pantAvgift = sackCount * pantUnitPrice;
    returPantLabel.innerHTML = `Säckpant (${sackCount} st): ${formatMoney(pantAvgift)}<br>`;
  }

  if (returOffset > 0) {
    const pantReturAvgift = returOffset * pantUnitPrice;
    returPantLabel.innerHTML += `Säckpant returavdrag (${returOffset} st): -${formatMoney(pantReturAvgift)}<br>`;
  }

  if (sackCount === 0 && returOffset === 0) {
    returPantLabel.innerHTML = `${state.quantity} säckar skall returneras<br>`;
  }

  const upsellTotal = getUpsellTotal(activePlanName);

  if (upsellTotal > 0) {
    upsellLabel.innerHTML = `Tillbehör: ${formatMoney(upsellTotal)}<br>`;
  } else {
    upsellLabel.innerHTML = '';
  }

  const totalPriceEl = document.querySelector('#total-price');
  if (totalPriceEl) totalPriceEl.textContent = formatMoney(total);

  let jfmUnitPrice;
  if (isSubscription) {
    jfmUnitPrice = state.sellingPlan.price / state.quantity;
  } else {
    jfmUnitPrice = productMetadata.unit_price * (1 - (discountMultiplier / 100));
  }
  document.querySelector('#jfm-price').textContent = `Jämförelsepris: ${formatMoney(jfmUnitPrice)}/säck`;

  buybox?.refreshPricing();

  return orderPricing;
}

// Handle add to cart
function onAddToCart(btn) {
  const cartItems = [];

  // Main item
  const mainItem = {
    id: productMetadata.id,
    quantity: state.quantity,
    properties: { // called 'attributes' in Shopify
      'Förpackning': 'Storsäck (2 m³/säck)',
      'Leveransmånad': `${getDateLabel(state.deliverymonth)}`,

      // Used for invoice + weight calculation
      '_quantity_total': state.quantity
    },
  };

  if (state.purchaseType === 'subscription' && state.sellingPlan) {
    mainItem.selling_plan = state.sellingPlan.id;
  }

  cartItems.push(mainItem);

  if (freeGiftEnabled) {
    cartItems.push({
      id: freeGiftProduct,
      quantity: 1
    });
  }

  // Add express avgift if deliverymonth is 'now'
  if (state.deliverymonth === 'now') {
    cartItems.push({
      id: expressAvgiftArtikel,
      quantity: 1
    });
  }

  // Calculate sack pant count and retur offset
  const { sackCount, returOffset } = calculateSackPant();

  // Add sack pant if applicable
  if (sackCount > 0) {

    let pantItem = {
      id: pantSackArtikel.id,
      quantity: sackCount
    };

    // If subscription, add selling plan
    if (state.purchaseType === 'subscription' && state.sellingPlan) {
      const foundSellingPlan = pantSackArtikel.selling_plans.find(plan => plan.name === state.sellingPlan.name);

      // If selling plan is found, add it to the item
      if (foundSellingPlan) {
        pantItem.selling_plan = foundSellingPlan.id;
      } else {
        console.warn('[storsack_buyform.js] No selling plan found for sack pant!');
      }
    }

    // Add sack pant to cart
    cartItems.push(pantItem);
  }

  // Add upsell items
  if (Object.keys(upsellInventoryCache).length > 0) {
    for (const [variantId, count] of Object.entries(upsellInventoryCache)) {
      // Skip free gift product
      if (freeGiftEnabled && variantId === freeGiftProduct) continue;

      if (count > 0) {
        const upsellItem = createUpsellCartItem(variantId, count);
        cartItems.push(upsellItem);
      }
    }
  }

  // Get the discount code for pant return
  const discountCode = getReturnDiscountCode(returOffset);

  clearCartIfNotEmpty().then(() => {
    addCartAttributes().then(() => {
      addCartItems(cartItems).then(async success => {
        if (success) {
          if (discountCode) await addCartDiscount(discountCode);

          // If user already added upsell items, go to cart
          if (Object.keys(upsellInventoryCache).length > 0) {
            window.location.href = '/cart';
          } else {
            // Show upsell popup
            showUpsellPopup();
          }

        } else {
          alert('Något gick fel. Vänligen försök igen.');
          setCartLoading(btn, false);
        }
      });
    });
  });
}

async function addCartDiscount(discountCode) {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ discount: discountCode || '' })
  });
}

// Show upsell popup on successful add to cart
function showUpsellPopup() {
  // Reset button loading state
  isButtonLoading = false;

  let modal = new Debutify.modal({
    closeMethods: ['overlay', 'button', 'escape'],
    size: 'small',
    closeIcon: 'close',
    selector: '.vedkungen-upsell-popup',
    boxClass: [],
    overlayClass: [],
    onOpen: function () { },
    onClose: function () { }
  });

  modal.open();
  modal._busy(true); // Do not allow closing

  // Skip button event handlers
  const skipButtons = modal.modalBox.querySelectorAll('#popup-skip');

  skipButtons.forEach(button => {
    button.addEventListener('click', function () {
      const button = modal.modalBox.querySelector('.button--full-width');
      if (isButtonLoading) return;
      setCartLoading(button, true);

      window.location.href = '/cart';
    });
  });

  // Upsell component event handler
  modal.modalBox.querySelector('dbtfy-slider-component').addEventListener('change', function (e) {
    if (e.target.matches('.quantity__input')) {
      const variantId = parseInt(e.target.dataset.quantityVariantId, 10);
      const newQty = parseInt(e.target.value, 10);

      if (newQty > 0) {
        popupUpsellInventoryCache[variantId] = newQty;
      } else {
        delete popupUpsellInventoryCache[variantId];
      }
    }
  });

  // Checkout button event handler
  modal.modalBox.querySelector('.button--full-width').addEventListener('click', function (e) {
    e.preventDefault();

    if (isButtonLoading) return;
    setCartLoading(this, true);

    if (Object.keys(popupUpsellInventoryCache).length == 0) {
      window.location.href = '/cart';
    } else {
      const cartItems = [];

      for (const [variantId, count] of Object.entries(popupUpsellInventoryCache)) {
        if (count > 0) {
          const upsellItem = createUpsellCartItem(variantId, count);
          cartItems.push(upsellItem);
        }
      }

      addCartItems(cartItems).then(async success => {
        if (success) {
          window.location.href = '/cart';
        } else {
          alert('Något gick fel. Vänligen försök igen.');
          setCartLoading(this, false);
        }
      });
    }
  });
}

// Add cart attributes
// TODO fix selling plan frequency
async function addCartAttributes() {
  let body = {
    attributes: {
      'leverans_manad': state.deliverymonth,
      'Leveransmånad': getDateLabel(state.deliverymonth),
      'Förpackning': 'Storsäck (2 m³/säck)',
      'Torkning': 'Torr ved'
    }
  }

  // Add retur if applicable
  if (state.pantRetur > 0) {
    body.attributes['Storsäckar att returnera'] = `${state.pantRetur} st`;
  }

  // Add subscription details if applicable
  // Used for client email notifications, server-side is handled by vedkungen-leveranssystem (don't trust client)
  if (state.purchaseType === 'subscription' && state.sellingPlan) {
    const { date: renewalDate, label: renewalDateLabel } = VedkungenBuybox.getRenewalDate(
      state.deliverymonth,
      'year' // TODO hardcoded, should be dynamic based on selling plan frequency
    );

    body.attributes['subscription_renewal_date'] = renewalDate;
    body.attributes['subscription_renewal_date_label'] = renewalDateLabel;
  }

  await fetch('/cart/update.js', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  });
}

async function addCartItems(cartItems) {
  for (const cartItem of cartItems) {
    const success = await addCartItem(cartItem);
    if (!success) {
      return false;
    }
  }
  return true;
}

async function addCartItem(cartItem) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cartItem)
  })
    .then(res => res.ok)
    .catch(() => false);
}

// Clear cart & discounts
async function clearCartIfNotEmpty() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  // Remove all discounts
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: '' })
  })
  .then(res => res.ok)
  .catch((error) => {
    console.error('[clearCartIfNotEmpty] Error removing discounts:', error);
  });

  // Clear cart
  if (cart.items.length > 0) {
    await fetch('/cart/clear.js', { method: 'POST' })
    .then(res => res.ok)
    .catch((error) => {
      console.error('[clearCartIfNotEmpty] Error clearing cart:', error);
    });
  }
}

function getReturnDiscountCode(returOffset) {
  return returOffset > 0 ? `PANTRETUR_${returOffset}` : undefined;
}

// Get best discount for the current antal
function getBestDiscount() {
  const validDiscounts = productMetadata.discount.filter(d => d.minsta_antal <= state.quantity);
  if (validDiscounts.length === 0) return 0;

  let bestDiscount = 0;
  let found = false;

  for (let d of validDiscounts) {
    if (d.rabatt_procent > bestDiscount) {
      found = true;
      bestDiscount = d.rabatt_procent;
    }
  }

  if (found) {
    return bestDiscount;
  } else {
    return 0;
  }
}

function getDateLabel(dateString) {
  if (dateString === 'now') {
    const expressFee = getExpressFee();
    return `Omgående (+${formatMoney(expressFee)} expressavgift)`;
  } else {
    const date = new Date(dateString + '-01');
    const monthText = date.toLocaleString('sv-SE', { month: 'long' });
    const year = date.getFullYear();

    return `${monthText} ${year}`;
  }
}

function formatMoney(amount) {
  amount = Math.round(Number(amount));
  return amount.toLocaleString('sv-SE') + ' kr';
}

function calculateSackPant() {
  let sackCount = state.quantity;
  let returOffset = state.pantRetur;


  // Substract any pant bags we are returning
  if (returOffset > 0) {

    // If we have more pant bags than we can return, minimize to available count
    const sackMinimized = Math.min(returOffset, sackCount);
    sackCount = Math.max(0, sackCount - returOffset);

    // Update to reflect how many bags we couldn't return
    returOffset = Math.max(0, returOffset - sackMinimized);
  }

  return { sackCount, returOffset };
}

// Only allow numbers in postnummer input
document.querySelector('#postnummer').addEventListener('input', function () {
  // Reset warning message
  document.querySelector('#postnummer-text').textContent = '';
  document.querySelector('#postnummer-notification').className = '';

  // Format / sanitize as XXX XX if we have more than 3 digits

  // Keep digits only, remove everything else (e, -, spaces, etc.)
  this.value = this.value.replace(/\D/g, "");

  // Limit to max 5 digits
  if (this.value.length > 5) {
    this.value = this.value.slice(0, 5);
  }

  // Format as XXX XX if we have more than 3 digits
  if (this.value.length > 3) {
    this.value = this.value.slice(0, 3) + " " + this.value.slice(3);
  }

  let isValid = false;

  if (this.value.length === 6) {
    isValid = validatePostnummer(this.value);
  }

  if (isValid) this.blur();

  // Editing invalidates a previously approved postnummer
  state.postnummerValid = isValid;
  syncBuyboxVisibility();
});

document.querySelector('#postnummer').addEventListener('keydown', function (e) {
  if (e.key === 'Enter') validatePostnummer(this.value);
});

function validatePostnummer(zipCode) {
  if (!zipCode) {
    document.querySelector('#postnummer').classList.add('empty');
    return false;
  }

  document.querySelector('#postnummer').classList.remove('empty');

  const postnummerNotification = document.querySelector('#postnummer-notification');
  const postnummerText = document.querySelector('#postnummer-text');

  const sanitizedInt = parseInt(zipCode.replace(/\s/g, ''), 10);
  const valid = /^\d{5}$/.test(sanitizedInt);

  // Reset messages
  postnummerNotification.className = '';
  postnummerText.innerHTML = '';

  if (valid) {
    const validatePostnummer = sanitizedInt >= postnummerMin && sanitizedInt <= postnummerMax;

    if (validatePostnummer) {
      postnummerNotification.classList.add('ved-bundle-notification');
      postnummerText.textContent = '✅ Du bor inom vårt upptagningsområde, vi kan leverera hem till dig.';
      state.postnummerValid = true;
      document.querySelector('#postnummer').classList.remove('empty');
      return true;
    } else {
      postnummerNotification.classList.add('ved-bundle-notification', '--red');
      postnummerText.innerHTML = '❌ Tyvärr, du bor utanför vårt upptagningsområde. Tror du att detta är fel? <a href="/pages/hjalp">Kontakta oss här</a> så hjälper vi dig!';
      state.postnummerValid = false;
    }
  } else {
    postnummerNotification.classList.add('ved-bundle-notification', '--red');
    postnummerText.textContent = '❌ Du angav ett ogiltigt postnummer. Vänligen ange ett giltigt postnummer (5 siffror).';
    state.postnummerValid = false;
  }

  document.querySelector('#postnummer').classList.add('empty');

  return false;
}
